"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormatters = exports.getTranslator = exports.store = exports.useStore = void 0;
const zustand_1 = require("zustand");
const constants_js_1 = require("./constants.js");
const getLocale = () => {
    try {
        return localStorage?.getItem(constants_js_1.LOCAL_STORAGE_KEY_LOCALE) ?? constants_js_1.DEFAULT_LOCALE;
    }
    catch {
        // When in private mode, localStorage can throw
        return constants_js_1.DEFAULT_LOCALE;
    }
};
exports.useStore = (0, zustand_1.create)(() => ({
    loading: false,
    locale: getLocale(),
    translator: null,
    formatters: null,
}));
exports.store = {
    initialize: (translator, formatters) => {
        exports.useStore.setState({
            translator,
            formatters,
        });
    },
    startLoading: () => {
        exports.useStore.setState({ loading: true });
    },
    stopLoading: () => {
        exports.useStore.setState({ loading: false });
    },
    setError: (message) => {
        exports.useStore.setState({ loading: false, error: message });
    },
    change: (locale, translator, formatters) => {
        exports.useStore.setState({
            locale,
            translator,
            formatters,
        });
    },
};
const getTranslator = () => exports.useStore.getState().translator;
exports.getTranslator = getTranslator;
const getFormatters = () => exports.useStore.getState().formatters;
exports.getFormatters = getFormatters;
//# sourceMappingURL=store.js.map